import { Action } from '@/_core/fluxstore/types';
import { AccountState } from '../types';
import { useAccountStore } from '../useModule';
import { useSendCommand } from '@/_core/cqrs/use';
import { UpdateProfileCommand } from '@/api/account/commands';
import { useCurrentUserModule, UpdateCurrentUser } from '../../currentUser';

const { registerMiddleware, registerReducer } = useAccountStore();

export class UpdateProfile extends Action<AccountState> {
    public static ACTION_TYPE = 'UpdateProfile';

    public constructor(public name: string, public email: string, public subscribeToNewsletter: boolean) {
        super(UpdateProfile.ACTION_TYPE);
    }
}

const middleware = async (state: AccountState, action: UpdateProfile): Promise<boolean> => {
    return await useSendCommand(action, {
        createCommand: () => new UpdateProfileCommand(action.name, action.email, action.subscribeToNewsletter),
        onSuccess: () => {
            const currentUserStore = useCurrentUserModule();
            currentUserStore.dispatch(new UpdateCurrentUser(action.name, action.email));
        },
    });
};

const reducer = (state: AccountState, action: UpdateProfile): void => {
    state.name = action.name;
    if (state.email != action.email) {
        //state.email = action.email; //TODO: ez lehet nem is kell ide?
        state.hasPendingEmailAddressChange = true;
    }
    state.subscribeToNewsletter = action.subscribeToNewsletter;
};

//@ts-ignore
registerMiddleware(UpdateProfile.ACTION_TYPE, middleware);

//@ts-ignore
registerReducer(UpdateProfile.ACTION_TYPE, reducer);
